import { useState, useEffect } from "react";
// Define general type for useWindowSize hook, which includes width and height
type Size = {
    width: number | undefined;
    height: number | undefined;
};

// Hook
export default function useWindowSize(): Size {
    // Initialize state with undefined width/height so server and client renders match
    const [windowSize, setWindowSize] = useState<Size>({
        width: undefined,
        height: undefined,
    });
    useEffect(() => {
        // Handler to call on window resize
        function handleResize() {
            // Set window width/height to state
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }
        // Add event listener
        window.addEventListener("resize", handleResize);
        // Call handler right away so state gets updated with initial window size
        handleResize();
        // Remove event listener on cleanup
        return () => window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
}

export function useIsWindowSmall(): boolean {
    const windowSize = useWindowSize();
    // Uses medium breakpoint from src\Theme\Components\_Mixins.scss
    return !!windowSize.width && windowSize.width < 768;
}
